import { render, staticRenderFns } from "./check-barge-dialog.vue?vue&type=template&id=0c4162dc&"
import script from "./check-barge-dialog.vue?vue&type=script&lang=js&"
export * from "./check-barge-dialog.vue?vue&type=script&lang=js&"
import style0 from "./check-barge-dialog.vue?vue&type=style&index=0&id=0c4162dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports